<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="99%">
    <template v-slot:title>Add From Allocations</template>
    <v-row justify="center" align="center">
      <v-col cols="2">
        <date-range-picker
          :gt-date-from-string="startDate"
          :gt-date-to-string="endDate"
          :outlined="outlinedInputs"
          @onRangeSelected="onDatesChange"
          hide-details
          dense
        ></date-range-picker>
      </v-col>
      <v-col
        ><destination-list-select
          v-model="destinationId"
          :outlined="outlinedInputs"
          hide-details
          dense
        ></destination-list-select
      ></v-col>
      <v-col>
        <v-text-field
          label="Allocation"
          v-model="allocationNameFilter"
          hide-details
          dense
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-text-field
          label="Supplier"
          v-model="supplierNameFilter"
          hide-details
          dense
          :outlined="outlinedInputs"
        />
      </v-col>

      <v-col>
        <template-list-select
          v-model="selectedTemplate"
          :filter="{ destinationId }"
          :outlined="outlinedInputs"
          hide-details
          dense
        ></template-list-select>
      </v-col>
      <v-col>
        <v-switch
          label="Only Show Available"
          v-model="showOnlyAvailable"
          hide-details
          dense
          class="my-0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table border="1">
          <thead class="v-data-table-header">
            <tr>
              <th class="text-left">Allocation</th>
              <th class="text-left">Supplier</th>
              <th class="text-left">Service</th>
              <th>Type</th>
              <th>Ad/Ch/Inf</th>
              <th>Qty</th>
              <th>
                Price From
                <v-btn icon text @click="onSortByPrice"
                  ><v-icon>{{
                    `mdi-sort-${sortByPriceDirection}`
                  }}</v-icon></v-btn
                >
              </th>
              <th v-for="day in days" :key="day">
                {{ day | formatDate }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="uid in Object.keys(byAllocation)" :key="uid">
              <td>{{ byAllocation[uid][0].name }}</td>
              <td>{{ byAllocation[uid][0].service.supplier.name }}</td>
              <td>{{ byAllocation[uid][0].service.name }}</td>
              <td class="text-center">
                <v-icon>{{
                  byAllocation[uid][0].type == "pax"
                    ? "mdi-account"
                    : "mdi-format-list-numbered"
                }}</v-icon>
              </td>
              <td class="text-center">
                <v-edit-dialog
                  large
                  cancel-text="Cancel"
                  @save="onPaxChange(paxSetup[uid])"
                >
                  <strong style="text-decoration: underline"
                    >{{ paxSetup[uid].adults }}/{{ paxSetup[uid].children }}/{{
                      paxSetup[uid].infants
                    }}</strong
                  >
                  <template v-slot:input>
                    <v-text-field
                      v-model="paxSetup[uid].adults"
                      type="number"
                      label="Adults"
                      min="1"
                      :max="headerProps ? headerProps.adults : 10"
                    ></v-text-field>
                    <v-text-field
                      v-model="paxSetup[uid].children"
                      type="number"
                      label="Children"
                      min="0"
                      :max="headerProps ? headerProps.children : 10"
                    ></v-text-field>
                    <v-text-field
                      v-model="paxSetup[uid].infants"
                      type="number"
                      label="Infants"
                      min="0"
                      :max="headerProps ? headerProps.infants : 10"
                      hide-details
                    ></v-text-field>
                    <v-switch
                      label="Apply to All"
                      v-model="paxApplyToAll"
                      dense
                      hide-details
                      class="mb-2"
                    ></v-switch>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-edit-dialog large cancel-text="Cancel">
                  <strong style="text-decoration: underline">{{
                    paxSetup[uid].qty
                  }}</strong>
                  <template v-slot:input>
                    <v-text-field
                      v-model="paxSetup[uid].qty"
                      type="number"
                      label="Qty"
                      min="1"
                      :max="999"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                {{
                  byAllocation[uid][0].pricedService
                    ? `${byAllocation[uid][0].pricedService.priceFromCurrencyCode}${byAllocation[uid][0].pricedService.priceFrom}`
                    : 0.0
                }}
              </td>

              <td v-for="day in days" :key="day" class="text-center">
                <v-icon
                  color="teal"
                  v-if="allocationForDate(day, uid).selected"
                  @click="onAllocationDayClick(day, uid)"
                  >mdi-check</v-icon
                >
                <v-chip
                  v-else
                  :disabled="
                    allocationForDate(day, uid).currentRemaining <= 0 ||
                    !dayValidForTemplateItem(
                      day,
                      byAllocation[uid][0].service.id
                    ) ||
                    (day == days[days.length - 1] &&
                      byAllocation[uid][0].service.supplier.serviceType ==
                        'ACCOMMODATION') ||
                    allocationForDate(day, uid).currentRemaining <
                      (byAllocation[uid][0].type == 'pax'
                        ? paxSetup[uid].adults
                        : paxSetup[uid].qty)
                  "
                  link
                  :color="
                    allocationForDate(day, uid).currentRemaining > 0
                      ? allocationForDate(day, uid).selected
                        ? `green`
                        : `green lighten-4`
                      : `red lighten-3`
                  "
                  @click="onAllocationDayClick(day, uid)"
                  >{{ allocationForDate(day, uid).currentRemaining }}
                </v-chip>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

    <v-row v-if="selectedTemplate != ''">
      <v-col>
        <h5 class="subtitle">Services without allocations</h5>
        <v-card outlined>
          <v-data-table
            :items="templateItems"
            :headers="templateServicesHeaders"
            show-select
            hide-default-footer
            v-model="selectedTemplateItems"
          >
            <template v-slot:item.adults="{ item }">
              <v-edit-dialog
                large
                cancel-text="Cancel"
                @save="onPaxChange(item)"
              >
                <strong style="text-decoration: underline"
                  >{{ item.adults }}/{{ item.children }}/{{
                    item.infants
                  }}</strong
                >
                <template v-slot:input>
                  <v-text-field
                    v-model="item.adults"
                    type="number"
                    label="Adults"
                    min="1"
                    :max="headerProps ? headerProps.adults : 10"
                  ></v-text-field>
                  <v-text-field
                    v-model="item.children"
                    type="number"
                    label="Children"
                    min="0"
                    :max="headerProps ? headerProps.children : 10"
                  ></v-text-field>
                  <v-text-field
                    v-model="item.infants"
                    type="number"
                    label="Infants"
                    min="0"
                    :max="headerProps ? headerProps.infants : 10"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.qty="{ item }">
              <v-edit-dialog large cancel-text="">
                <strong style="text-decoration: underline">{{
                  item.qty
                }}</strong>
                <template v-slot:input>
                  <v-text-field
                    v-model="item.qty"
                    type="number"
                    label="Qty"
                    min="1"
                    :max="999"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.startDate="{ item }">
              {{ item.startDate | formatDate }}
            </template>
            <template v-slot:item.endDate="{ item }">
              {{ item.endDate | formatDate }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="!selected || Object.keys(selected).length == 0"
        @click="onAdd"
        >Add</v-btn
      >
    </template>
    <div v-if="debug">
      <code>--{{ showOnlyAvailable }}--</code>
      <code>{{ byAllocation }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../../shared/BasicDialog";
import DateRangePicker from "../../../shared/DatesRangePicker";
import DestinationListSelect from "../../../shared/DestinationListSelect";
import TemplateListSelect from "../../../shared/TemplateListSelect";
import QtyDialog from "../../../shared/QtyDialog";
import {
  groupByProp,
  groupByFn,
  removeGQLTypename,
  getDatesForTemplateItem,
  getTotal,
  sortByFn,
} from "../../../../../helpers";

const moment = require("moment");
var randomize = require("randomatic");
export const TEMPLATE_DETAILS_QUERY = gql`
  query template($id: ID!) {
    template(id: $id) {
      id
      duration
      items {
        edges {
          node {
            id
            service {
              id
              name
              stdOccupancy
            }
            supplier {
              id
              name
              serviceType
              defaultRateTypeCode
            }
            day
            duration
            itemBuy
            itemSell
            adultBuy
            adultSell
            childBuy
            childSell
            infantBuy
            infantSell
            currencyBuy
            currencySell
            rateTypeCode
            totalSell
            totalBuy
            customPricing
            extras {
              edges {
                node {
                  id
                  extraId
                  name
                  day
                  duration
                  isChildOnly
                  isInfantOnly
                }
              }
            }
          }
        }
      }
    }
  }
`;
const ALLOCATIONS = gql`
  query allAllcations($filter: AllocationFilterType) {
    allocations(filter: $filter) {
      edges {
        node {
          service {
            id
            name
            stdOccupancy
            supplier {
              id
              name
              serviceType
            }
          }
          id
          uid
          name
          date
          qty
          taken
          type
          maxTotal
        }
      }
    }
  }
`;
const SFR = gql`
  query sfr(
    $search: AvailableServicesSearchInput!
    $filter: AvailableServiceFilterType
  ) {
    availableServicesBySupplier(
      page: 1
      pageSize: 1000
      searchParams: $search
      filter: $filter
    ) {
      totalCount
      edges {
        node {
          id
          supplierName
          supplierId
          availableServices {
            serviceId
            serviceName
            priceFrom
            priceFromCurrencyCode
          }
        }
      }
    }
  }
`;
export default {
  name: "add-from-allocations-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    headerProps: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    DateRangePicker,
    DestinationListSelect,
    TemplateListSelect,
  },

  data() {
    return {
      debug: false,
      startDate: this.headerProps ? this.headerProps.startDate : "",
      endDate: this.headerProps ? this.headerProps.endDate : "",
      destinationId: this.headerProps ? this.headerProps.destinationId : "",
      agentId: this.headerProps ? this.headerProps.agentId : "",
      selectedTemplate: "",
      items: [],
      templateItems: [],
      selectedTemplateItems: [],
      templateServicesFilter: [],
      paxSetup: {},
      roomsQty: 1,
      showQtyDialog: false,
      templateServicesHeaders: [
        {
          text: "Supplier",
          value: "supplier.name",
        },
        {
          text: "Service",
          value: "service.name",
        },
        {
          text: "Ad/Ch/Inf",
          value: "adults",
          name: "pax",
        },
        {
          text: "Qty",
          value: "qty",
          name: "qty",
        },
      ],
      sortByPriceDirection: "ascending",
      allocationNameFilter: "",
      supplierNameFilter: "",
      paxApplyToAll: false,
      showOnlyAvailable: false,
    };
  },

  computed: {
    sfrSearchParams() {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        adults: this.headerProps.adults,
        children: this.headerProps.children,
        infants: this.headerProps.infants,
        department: this.headerProps.department,
        agentId: this.headerProps.agentId,
        destinationId: this.destinationId,
        serviceTypes: [
          ...new Set(
            this.items.map((item) => item.service.supplier.serviceType)
          ),
        ],
        services: [...new Set(this.items.map((item) => item.service.id))],
      };
    },
    templateServicesWithoutAlloc() {
      return this.selectedTemplate != "" &&
        this.template &&
        this.template.items.edges
        ? this.template.items.edges
            .filter(
              (item) =>
                !this.items.find((a) => a.service.id == item.node.service.id)
            )
            .map(removeGQLTypename)
        : [];
    },

    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },

    days() {
      const days = [];
      const a = moment(this.startDate);
      const b = moment(this.endDate);
      for (const m = moment(a); m.diff(b, "days") <= 0; m.add(1, "days")) {
        days.push(m.format("YYYY-MM-DD"));
      }
      return days;
    },

    selected() {
      const selectedbyAllocation = groupByFn(
        this.items.filter((item) => item.selected),
        this.groupingFn
      );
      return Object.keys(selectedbyAllocation).reduce((a, key) => {
        a[key] = {
          serviceId: selectedbyAllocation[key][0].service.id,
          serviceType:
            selectedbyAllocation[key][0].service.supplier.serviceType,
          serviceName: selectedbyAllocation[key][0].service.name,
          stdOccupancy: selectedbyAllocation[key][0].service.stdOccupancy,
          supplierName: selectedbyAllocation[key][0].service.supplier.name,
          allocation: selectedbyAllocation[key][0].uid,
          stays: this.getStays(selectedbyAllocation[key]),
        };
        return a;
      }, {});
    },

    byAllocation() {
      const sortedAsc = this.withPrices(this.items)
        .sort(
          sortByFn((item) =>
            item.pricedService ? Number(item.pricedService.priceFrom) : 0
          )
        )
        .filter((item) => {
          let b = true;
          if (this.allocationNameFilter != "") {
            b = item.name
              .toLowerCase()
              .includes(this.allocationNameFilter.toLowerCase());
          }
          if (this.supplierNameFilter != "") {
            b =
              b &&
              item.service.supplier.name
                .toLowerCase()
                .includes(this.supplierNameFilter.toLowerCase());
          }
          return b;
        });
      const ba = groupByFn(
        this.sortByPriceDirection == "descending"
          ? sortedAsc.reverse()
          : sortedAsc,
        this.groupingFn
      );
      if (this.showOnlyAvailable) {
        //console.log(this.showOnlyAvailable, ba)
        return Object.keys(ba).reduce((a, key) => {
          //https://tracker.globetrack.ie/issues/9088
          //probably we need prioper remaining calculation
          const notAvailable = ba[key].filter(
            (item) => item.qty - item.taken <= 0
          );
          if (notAvailable.length > 0) {
            return a;
          } else {
            a[key] = ba[key];
          }
          return a;
        }, {});
      } else {
        return ba;
      }
    },

    itineraryItems() {
      const items = Object.keys(this.selected).reduce((allocItems, key) => {
        const { stays, ...serviceInfo } = this.selected[key];
        const paxSetup = this.paxSetup[key];
        const totalPax = Number(paxSetup.adults) + Number(paxSetup.children);
        const itemQty = Math.ceil(totalPax / Number(serviceInfo.stdOccupancy));

        for (const stay of stays) {
          const startDate = stay[0];
          const endDate = stay[stay.length - 1];
          allocItems.push({
            id: randomize("Aa0", 32),
            status: "Confirmed",
            statusId: "U2VydmljZVN0YXR1cy0z",
            qty: itemQty,
            price: 0,
            isIncluded: true,
            isOptional: false,
            rateTypeCode: "",
            selected: false,
            remarks: {},
            customPricing: false,
            ...serviceInfo,
            startDate,
            endDate:
              serviceInfo.serviceType == "ACCOMMODATION"
                ? moment(endDate)
                    .startOf("day")
                    .add(1, "day")
                    .startOf("day")
                    .format("YYYY-MM-DD")
                : endDate,
            ...paxSetup,
          });
        }
        return allocItems;
      }, []);

      if (this.selectedTemplate != "") {
        for (const templateItem of this.selectedTemplateItems) {
          items.push({
            id: randomize("Aa0", 32),
            status: "Confirmed",
            statusId: "U2VydmljZVN0YXR1cy0z",
            qty: templateItem.qty,
            price: 0,
            isIncluded: true,
            isOptional: false,
            rateTypeCode: "",
            selected: false,
            customPricing: false,
            ...getDatesForTemplateItem(this.startDate, templateItem),
            adults: templateItem.adults,
            children: templateItem.children,
            infants: templateItem.infants,
            serviceId: templateItem.service.id,
            serviceType: templateItem.supplier.serviceType,
            serviceName: templateItem.service.name,
            supplierName: templateItem.supplier.name,
          });
        }
      }
      return items;
    },
  },

  watch: {
    headerProps(newProps) {
      this.startDate = newProps.startDate;
      this.endDate = newProps.endDate;
      this.destinationId = newProps.destinationId;
      this.agentId = newProps.agentId;
    },
  },

  methods: {
    onSortByPrice() {
      this.sortByPriceDirection =
        this.sortByPriceDirection == "ascending" ? "descending" : "ascending";
    },
    withPrices(items) {
      if (
        this.availableServicesBySupplier &&
        this.availableServicesBySupplier.edges &&
        this.availableServicesBySupplier.edges.length > 0
      ) {
        const sfrSuppliers =
          this.availableServicesBySupplier.edges.map(removeGQLTypename);
        //console.log(sfrSuppliers);
        return items.map((item) => {
          const pricedSupplier = sfrSuppliers.find(
            (s) => s.supplierId == item.service.supplier.id
          );
          if (pricedSupplier) {
            const pricedService = pricedSupplier.availableServices.find(
              (as) => as.serviceId == item.service.id
            );
            if (pricedService) {
              item.pricedService = { ...pricedService };
            }
          }
          return item;
        });
      } else {
        return items;
      }
    },
    onPaxChange(item) {
      item.qty = Math.ceil(
        (Number(item.adults) + Number(item.children)) /
          Number(item.stdOccupancy)
      );
      if (this.paxApplyToAll) {
        Object.keys(this.paxSetup).forEach((key) => {
          this.paxSetup[key] = { ...item };
        });
      }
    },
    groupingFn(item) {
      return `${item.uid}_${item.service.id}`;
    },
    onAdd() {
      this.$emit("add", [...this.itineraryItems]);
    },
    getStays(items) {
      let i = 0;
      return this.days.reduce((stack, day) => {
        const allocForDay = items.find((item) => item.date == day);

        if (allocForDay) {
          if (!stack[i]) {
            stack[i] = [];
          }
          stack[i].push(allocForDay.date);
        } else {
          //console.log("no allocation for", day);
          if (stack[i]) {
            i++;
          }
        }
        return stack;
      }, []);
    },
    onDatesChange(range) {
      this.startDate = range.dateFrom;
      this.endDate = range.dateTo;
    },
    allocationForDate(date, key) {
      const [uid, serviceId] = key.split("_");

      const allPerDay = this.items.filter((item) => {
        //console.log(item, item.day, date, item.uid, uid);
        return item.date == date && item.uid == uid;
      });

      const a = allPerDay.find((item) => item.service.id == serviceId);
      const overallTaken = getTotal(allPerDay, (item) => item.taken);
      //https://tracker.globetrack.ie/issues/9053
      const currentTaken = allPerDay.reduce((taken, item) => {
        const paxKey = `${item.uid}_${item.service.id}`;
        taken += item.selected
          ? item.type == "pax"
            ? Number(this.paxSetup[paxKey].adults)
            : Number(this.paxSetup[paxKey].qty)
          : 0;

        return taken;
      }, 0);
      //console.log("currentTaken", currentTaken);
      if (a) {
        //same calculation as on rails (service.rb:560)
        let remaining = a.maxTotal - a.taken;
        const remainingOverall = a.qty - overallTaken;
        remaining = remainingOverall < remaining ? remainingOverall : remaining;

        return {
          ...a,
          remaining,
          currentRemaining: remaining - currentTaken,
        };
      } else {
        return { remaining: 0, currentRemaining: 0 };
      }
    },
    onAllocationDayClick(date, key) {
      const [uid, serviceId] = key.split("_");
      const a = this.items.find(
        (item) =>
          item.date == date && item.uid == uid && item.service.id == serviceId
      );
      const editedIndex = this.items.indexOf(a);
      Object.assign(this.items[editedIndex], { ...a, selected: !a.selected });
    },
    setupPax() {
      this.paxSetup = Object.keys(this.byAllocation).reduce((paxSetup, uid) => {
        const adt = this.headerProps ? this.headerProps.adults : 2;
        const chd = this.headerProps ? this.headerProps.children : 0;
        const inf = this.headerProps ? this.headerProps.infants : 0;
        const pax = Number(adt) + Number(chd);
        const std = Number(this.byAllocation[uid][0].service.stdOccupancy);
        paxSetup[uid] = {
          adults: adt,
          children: chd,
          infants: inf,
          stdOccupancy: std,
          qty: Math.ceil(pax / std),
        };
        return paxSetup;
      }, {});
    },
    dayValidForTemplateItem(day, serviceId) {
      if (this.selectedTemplate == "") {
        return true;
      } else {
        if (this.template && this.template.items) {
          const templateItem = this.template.items.edges.find(
            (item) => item.node.service.id == serviceId
          );

          if (templateItem) {
            const itemDates = getDatesForTemplateItem(
              this.startDate,
              templateItem.node
            );

            return moment(day)
              .startOf("day")
              .isBetween(itemDates.startDate, itemDates.endDate, "days", "[]");
          }
        }

        return true;
      }
    },
  },

  apollo: {
    template: {
      query: TEMPLATE_DETAILS_QUERY,
      variables() {
        return { id: this.selectedTemplate };
      },
      skip() {
        return this.selectedTemplate == "";
      },

      result(res) {
        this.templateServicesFilter = this.template.items
          ? this.template.items.edges.map((item) => item.node.service.id)
          : [];
      },
      fetchPolicy: "network-only",
    },
    allocations: {
      query: ALLOCATIONS,
      variables() {
        return {
          filter: {
            date_gte: this.startDate,
            date_lte: this.endDate,
            destinationId: this.destinationId,
            services:
              this.selectedTemplate != ""
                ? this.templateServicesFilter
                : undefined,
            agentId: this.agentId != "" ? this.agentId : undefined,
          },
        };
      },
      result({ data }) {
        this.items = data.allocations.edges
          .map(removeGQLTypename)
          .map((item) => ({
            ...item,

            selected: false,
          }));
        this.setupPax();
        this.templateItems = this.templateServicesWithoutAlloc.map((item) => {
          const adt = this.headerProps ? this.headerProps.adults : 2;
          const chd = this.headerProps ? this.headerProps.children : 0;
          const inf = this.headerProps ? this.headerProps.infants : 0;
          const pax = Number(adt) + Number(chd);
          const std = Number(item.service.stdOccupancy);
          return {
            ...item,
            adults: adt,
            children: chd,
            infants: inf,
            stdOccupancy: std,
            qty: Math.ceil(pax / std),
          };
        });
        this.selectedTemplateItems = [...this.templateItems];
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "network-only",
    },
    availableServicesBySupplier: {
      query: SFR,
      variables() {
        return {
          search: { ...this.sfrSearchParams },
        };
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
table,
td,
th {
  border: 1px solid #ddd;
}

table {
  border-collapse: collapse;
  display: table;
  width: 100%;
  table-layout: fixed;
}

tr td:hover {
  background-color: #f5f5f5;
}

th,
td {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/AddFromAllocationsDialog.vue